export default function ReWork() {
  return (
    <div>
      <div className="hero bg-base-200 min-h-screen">
        <div className="hero-content text-center">
          <div className="max-w-md">
            <h1 className="text-5xl font-bold">🚧 Being redone 🚧</h1>
            <p className="py-6">
              Hiii this site is currently being re done, until then visit my
              retro site!
            </p>
            <a className="btn btn-primary" href="https://saahild.com/retro">
              Retro site
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
